import React, { useEffect } from 'react';
import ServiceTemplate from '../components/ServiceTemplate';

const PartnershipDevelopment = () => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--service-bg-image',
      "url('https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=2069&auto=format&fit=crop')"
    );
    return () => {
      document.documentElement.style.removeProperty('--service-bg-image');
    };
  }, []);
  const benefits = [
    {
      title: 'Strategic Alliances',
      description: 'Build powerful partnerships that create mutual value and open new opportunities for growth.'
    },
    {
      title: 'Market Expansion',
      description: 'Access new markets and customer segments through strategic partnership collaborations.'
    },
    {
      title: 'Resource Optimization',
      description: 'Leverage partner resources and capabilities to enhance your competitive position.'
    },
    {
      title: 'Innovation Acceleration',
      description: 'Drive innovation faster through collaborative partnerships and shared expertise.'
    }
  ];

  const features = [
    'Partnership strategy development',
    'Partner identification and evaluation',
    'Negotiation support and deal structuring',
    'Joint venture planning and setup',
    'Strategic alliance management',
    'Partnership performance monitoring',
    'Relationship management and optimization',
    'Conflict resolution and mediation',
    'Exit strategy planning',
    'Network development and ecosystem building'
  ];

  const process = [
    {
      title: 'Strategy Definition',
      description: 'Define your partnership objectives, criteria, and desired outcomes aligned with your business strategy.'
    },
    {
      title: 'Partner Identification',
      description: 'Research and identify potential partners that align with your goals and bring complementary value.'
    },
    {
      title: 'Evaluation & Selection',
      description: 'Conduct thorough due diligence and evaluation to select the best partnership opportunities.'
    },
    {
      title: 'Negotiation & Structuring',
      description: 'Facilitate negotiations and structure partnership agreements that protect interests and create mutual value.'
    },
    {
      title: 'Implementation & Management',
      description: 'Support partnership launch and ongoing management to ensure success and maximize value creation.'
    }
  ];

  return (
    <ServiceTemplate
      icon="🤝"
      title="Partnership Development"
      subtitle="Build strategic partnerships that drive mutual success and business growth"
      description="Our partnership development services help you identify, establish, and manage strategic partnerships that create value and competitive advantage. We guide you through every stage of the partnership lifecycle, from strategy development to implementation and ongoing management, ensuring successful collaborations that drive business growth."
      benefits={benefits}
      features={features}
      process={process}
      callToAction="Ready to build powerful partnerships that drive growth? Contact us to explore how we can help you develop strategic alliances that create lasting value."
    />
  );
};

export default PartnershipDevelopment;

